/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateInviteByMagicLinkDto,
  InviteDto,
  InviteeByMagicInviteDto,
  MagicInviteDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiMagicInviteController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-magic-invite-controller
   * @name GetMagicInvites
   * @request GET:/api/v1/invite/magic-link
   */
  getMagicInvites = (params: RequestParams = {}) =>
    this.http.request<MagicInviteDto[], any>({
      path: `/v1/invite/magic-link`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMagicInvitesPath = '/v1/invite/magic-link'
  static getMagicInvitesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-magic-invite-controller
   * @name CreateMagicInviteAndGetSecret
   * @request POST:/api/v1/invite/magic-link
   */
  createMagicInviteAndGetSecret = (params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/invite/magic-link`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static createMagicInviteAndGetSecretPath = '/v1/invite/magic-link'
  static createMagicInviteAndGetSecretMethod = 'POST'
  /**
   * No description
   *
   * @tags api-magic-invite-controller
   * @name CreateAndInviteUser
   * @request POST:/api/v1/invite/magic-link/invite
   */
  createAndInviteUser = (data: CreateInviteByMagicLinkDto, params: RequestParams = {}) =>
    this.http.request<InviteDto, any>({
      path: `/v1/invite/magic-link/invite`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createAndInviteUserPath = '/v1/invite/magic-link/invite'
  static createAndInviteUserMethod = 'POST'
  /**
   * No description
   *
   * @tags api-magic-invite-controller
   * @name GetInviteeInfoByMagicInviteId
   * @request GET:/api/v1/invite/magic-link/{magicInviteId}/invitee
   */
  getInviteeInfoByMagicInviteId = (magicInviteId: string, params: RequestParams = {}) =>
    this.http.request<InviteeByMagicInviteDto[], any>({
      path: `/v1/invite/magic-link/${magicInviteId}/invitee`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInviteeInfoByMagicInviteIdPath = '/v1/invite/magic-link/${magicInviteId}/invitee'
  static getInviteeInfoByMagicInviteIdMethod = 'GET'
}
